<script setup lang="ts">
import { close } from '@/components/icons/icons';
import Button from '@/components/buttons/Button.vue';
</script>

<template>
  <Button class="button" variant="ghost" size="small" :prependIcon="close">
    <slot>
      {{ $t('ResetFilter_other') }}
    </slot>
  </Button>
</template>

<style lang="scss" scoped>
.button {
  margin-top: 30px;
}
</style>
